import React, { useEffect, useState } from "react";
import { Card, Button, Modal, Form, Upload, message, Radio, Row, Col, Image } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { doPatch, doPost } from "../../../components/API/apis";
import { useStateGlobalContext } from "../../../Context/GlobalContext";

export const fallback= "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6UAAABRWlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSSwoyGFhYGDIzSspCnJ3UoiIjFJgf8LAwSDCIMogwMCcmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsis7PPOq3QdDFcvjV3jOD1boQVTPQrgSkktTgbSf4A4LbmgqISBgTEFyFYuLykAsTuAbJEioKOA7DkgdjqEvQHEToKwj4DVhAQ5A9k3gGyB5IxEoBmML4BsnSQk8XQkNtReEOBxcfXxUQg1Mjc0dyHgXNJBSWpFCYh2zi+oLMpMzyhRcASGUqqCZ16yno6CkYGRAQMDKMwhqj/fAIcloxgHQqxAjIHBEugw5sUIsSQpBobtQPdLciLEVJYzMPBHMDBsayhILEqEO4DxG0txmrERhM29nYGBddr//5/DGRjYNRkY/l7////39v///y4Dmn+LgeHANwDrkl1AuO+pmgAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAwqADAAQAAAABAAAAwwAAAAD9b/HnAAAHlklEQVR4Ae3dP3PTWBSGcbGzM6GCKqlIBRV0dHRJFarQ0eUT8LH4BnRU0NHR0UEFVdIlFRV7TzRksomPY8uykTk/zewQfKw/9znv4yvJynLv4uLiV2dBoDiBf4qP3/ARuCRABEFAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghgg0Aj8i0JO4OzsrPv69Wv+hi2qPHr0qNvf39+iI97soRIh4f3z58/u7du3SXX7Xt7Z2enevHmzfQe+oSN2apSAPj09TSrb+XKI/f379+08+A0cNRE2ANkupk+ACNPvkSPcAAEibACyXUyfABGm3yNHuAECRNgAZLuYPgEirKlHu7u7XdyytGwHAd8jjNyng4OD7vnz51dbPT8/7z58+NB9+/bt6jU/TI+AGWHEnrx48eJ/EsSmHzx40L18+fLyzxF3ZVMjEyDCiEDjMYZZS5wiPXnyZFbJaxMhQIQRGzHvWR7XCyOCXsOmiDAi1HmPMMQjDpbpEiDCiL358eNHurW/5SnWdIBbXiDCiA38/Pnzrce2YyZ4//59F3ePLNMl4PbpiL2J0L979+7yDtHDhw8vtzzvdGnEXdvUigSIsCLAWavHp/+qM0BcXMd/q25n1vF57TYBp0a3mUzilePj4+7k5KSLb6gt6ydAhPUzXnoPR0dHl79WGTNCfBnn1uvSCJdegQhLI1vvCk+fPu2ePXt2tZOYEV6/fn31dz+shwAR1sP1cqvLntbEN9MxA9xcYjsxS1jWR4AIa2Ibzx0tc44fYX/16lV6NDFLXH+YL32jwiACRBiEbf5KcXoTIsQSpzXx4N28Ja4BQoK7rgXiydbHjx/P25TaQAJEGAguWy0+2Q8PD6/Ki4R8EVl+bzBOnZY95fq9rj9zAkTI2SxdidBHqG9+skdw43borCXO/ZcJdraPWdv22uIEiLA4q7nvvCug8WTqzQveOH26fodo7g6uFe/a17W3+nFBAkRYENRdb1vkkz1CH9cPsVy/jrhr27PqMYvENYNlHAIesRiBYwRy0V+8iXP8+/fvX11Mr7L7ECueb/r48eMqm7FuI2BGWDEG8cm+7G3NEOfmdcTQw4h9/55lhm7DekRYKQPZF2ArbXTAyu4kDYB2YxUzwg0gi/41ztHnfQG26HbGel/crVrm7tNY+/1btkOEAZ2M05r4FB7r9GbAIdxaZYrHdOsgJ/wCEQY0J74TmOKnbxxT9n3FgGGWWsVdowHtjt9Nnvf7yQM2aZU/TIAIAxrw6dOnAWtZZcoEnBpNuTuObWMEiLAx1HY0ZQJEmHJ3HNvGCBBhY6jtaMoEiJB0Z29vL6ls58vxPcO8/zfrdo5qvKO+d3Fx8Wu8zf1dW4p/cPzLly/dtv9Ts/EbcvGAHhHyfBIhZ6NSiIBTo0LNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiEC/wGgKKC4YMA4TAAAAABJRU5ErkJggg=="

const MAX_FILE_SIZE = 10 * 1024 * 1024;

const ChangeAuthPageBanner = () => {
  const [form] = Form.useForm()
  const [visible, setVisible] = useState(false);
  const [authImage, setAuthImage] = useState(null);
  const [imageType, setImageType] = useState("login_image");
  const {appLogoData, getAppLogo ,bankInformation, getBankInformation} = useStateGlobalContext()


  const showModal = () => {
    setVisible(true);
  };

  const hideModal = () => {
    setVisible(false);
    form.resetFields();
    setImageType("login_image"); // Set default value for radio buttons
    setAuthImage(null); // Clear the file upload
  };

  const handleImageChange = (value) => {
    setImageType(value);
  };

  const officeLogoProps = {
    onRemove: () => {
      setAuthImage(null);
    },
    beforeUpload: (file) => {
      if (file.size > MAX_FILE_SIZE) {
        message.error("File size exceeds the maximum limit (10MB)");
        setAuthImage(null);
        return;
      }
      setAuthImage(file);
      return false;
    },
    maxCount: 1,
  };

  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const updateAuthImages = async () => {
    let imageModified = null;
    if (authImage) {
      imageModified = await convertToBase64(authImage);
    } else if(!authImage) {
      return message.error("Image is Required")
    }
    const data = {
      [imageType]: imageModified,
    };
    try {
      const url = bankInformation?.super_admin_payment_bank_info?.length > 0 &&  appLogoData?.sign_up_image > 0 || appLogoData?.login_image > 0 ? "/administration/update-application-images/" :
      "/administration/add-application-images/"
      const response = bankInformation?.super_admin_payment_bank_info?.length > 0 &&  appLogoData?.sign_up_image > 0 || appLogoData?.login_image > 0 ? await doPatch(url, data) : await doPost(url, data);
      if (response.status === 201) {
        message.success("Image Added Successfully");
        getAppLogo()
        hideModal();
      } else if (response.status === 200) {
        message.success("Image Updated Successfully");
        getAppLogo()
        hideModal();
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(()=>{
    getAppLogo()
    getBankInformation()
  },[])
  

  return (
    <Card className="mt-2">
      <div className="flex justify-between">
        <p className="font-bold text-md">Change Signup / Login Banner</p>
        <Button type="primary" onClick={showModal} className="mb-2">
          Update Banner
        </Button>
      </div>


      <Row gutter={[16,16]}>
          <Col sm={24} md={12} lg={12}>
            <Card className="flex justify-center">
              <p className="text-lg font-medium text-center mb-2">Login Image </p>
             <Image
             loading="lazy"
              src={appLogoData?.login_image}
              alt="Login"
              width={400}
              fallback={fallback}
              preview={appLogoData?.login_image?.length > 0}
             />
             </Card>
          </Col>
          <Col sm={24} md={12} lg={12}>
          <Card className="flex justify-center">
            <p className="text-lg font-medium text-center mb-2">Signup Image </p>
             <Image
             loading="lazy"
              src={appLogoData?.sign_up_image}
              alt="Signup"
              width={400}
              fallback={fallback}
              preview={appLogoData?.sign_up_image?.length > 0}
             />
             </Card>
          </Col>
      </Row>

      <Modal open={visible} footer={null} onCancel={hideModal}>
        <Form layout="vertical" onFinish={updateAuthImages}>
          <Form.Item label="Update Image" name='imagetype'
          
            rules={[{
              required: true,
              message: "Please Choose Image type First"
            }]}
          >
            <Radio.Group
              // defaultValue={'login_image'}
              buttonStyle="solid"
              size="large"
              onChange={(e) => handleImageChange(e.target.value)}
            >
              <Radio.Button value="login_image">Login Image</Radio.Button>
              <Radio.Button value="front_page_image">Signup Image</Radio.Button>
            </Radio.Group>
          </Form.Item>
          <Form.Item className="mt-4" label="Signup Image" name="Signup Image">
            <Upload
              {...officeLogoProps}
              accept=".jpg, jpeg, .png"
              multiple={false}
              maxCount={1}
            >
              <Button icon={<UploadOutlined />}>Click to Upload</Button>
            </Upload>
          </Form.Item>

          <div className="flex justify-end">
            <Button onClick={hideModal}>Cancel</Button>
            <Button htmlType="submit" type="primary" className="ml-2">Update</Button>
          </div>
        </Form>
      </Modal>
    </Card>
  );
};

export default ChangeAuthPageBanner;
